export default "__VITE_ASSET__C$N3AwCJ__"